import React from "react";
import { useHistory } from "react-router-dom";
import { LaunchHero } from "../../../components/landing/LaunchSections";

export const MOVE_LAUNCH = "Launching Beginning Q4 2026";

export default function MoveHero() {
  const history = useHistory();

  return (
    <LaunchHero
      image="/figma-assets/move/hero.jpg"
      imageAlt="Traveller getting into a rental car"
      pills={
        <>
          <span className="rounded-full bg-[#017bef] px-[16px] py-1.5 text-[12px] font-bold uppercase leading-4 tracking-[1.2px] text-white">
            SPACIA MOVE
          </span>
          <span className="rounded-full border-[1px] border-solid border-white px-[16px] py-1.5 text-[12px] font-semibold uppercase leading-4 tracking-[1.2px] text-white">
            Coming Soon
          </span>
          {/* The design has white text on this white pill; dark text keeps it readable */}
          <span className="rounded-full bg-white px-[16px] py-1.5 text-[12px] font-semibold leading-4 text-[#012d6e]">
            {MOVE_LAUNCH}
          </span>
        </>
      }
      titleLines={["Get Where You", "Need to Go"]}
      lead="Get where you need to go, with trusted car rental from accredited providers booked directly through SPACIA."
      body="Move brings car rental onto the SPACIA platform, connecting you with accredited rental companies for every stage of your journey."
      desktopBottomPadding={163}
      secondaryBorderClassName="border-white"
      primaryCta={{ label: "Get Started", onClick: () => history.push("/package-signup") }}
      secondaryCta={{ label: "List Your Fleet", onClick: () => history.push("/partner-signup") }}
    />
  );
}
